import { Component, OnInit } from '@angular/core';
import  templateSearch  from '../mockdata/templateSearch.json';

@Component({
  selector: 'cmpts-template-search',
  templateUrl: './template-search.component.html',
  styleUrls: ['./template-search.component.css']
})
export class TemplateSearchComponent implements OnInit {
  packageDatas = templateSearch;

  constructor() { }

  ngOnInit(): void {
  }

}
